import { render, staticRenderFns } from "./AddDemand.vue?vue&type=template&id=9340e772&scoped=true"
import script from "./AddDemand.vue?vue&type=script&lang=js"
export * from "./AddDemand.vue?vue&type=script&lang=js"
import style0 from "./AddDemand.vue?vue&type=style&index=0&id=9340e772&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9340e772",
  null
  
)

export default component.exports